// Tariff/TariffPage.tsx

import React, {useEffect, useState} from 'react';
import {CircularProgress, Typography} from '@mui/material';
import {useNavigate, useParams} from 'react-router-dom';
import {ITariff} from '../../Types/psychology/tariff';
import {axios, DOMAIN_URL} from 'Auth/axiosConfig';
import pprint from '../../Utils/pprint';
import {FC, FCCC} from 'WideLayout/Layouts';
import {useTheme} from 'Theme/ThemeContext';
import TariffDetail from "Tariff/TariffDetail";
import {useErrorProcessing} from "Core/components/ErrorProvider";
import Head from "Core/components/Head";

interface TariffPageProps {
    tariff?: ITariff;
    cls?: string;
}

const TariffPage: React.FC<TariffPageProps> = ({tariff: propTariff, cls}) => {
    const {productId} = useParams<{ productId: string }>();
    const [tariff, setTariff] = useState<ITariff | null>(propTariff || null);
    const [loading, setLoading] = useState<boolean>(!propTariff);
    const [error, setError] = useState<string | null>(null);
    const {plt} = useTheme();
    const navigate = useNavigate();
    const {byResponse} = useErrorProcessing();
    useEffect(() => {
        if (!propTariff && productId) {
            const fetchTariff = async () => {
                try {
                    const response = await axios.get(`/api/v1/tariffs/${productId}/`);
                    pprint('Tariff fetched:', response.data);
                    setTariff(response.data);
                } catch (e) {
                    byResponse(e);
                } finally {
                    setLoading(false);
                }
            };
            fetchTariff();
        }
    }, [productId, propTariff]);

    if (loading)
        return (
            <FCCC h={'100%'}>
                <CircularProgress size={'150px'}/>
            </FCCC>
        );
    if (error)
        return (
            <Typography color="error" align="center" mt={4}>
                {error}
            </Typography>
        );
    if (!tariff)
        return (
            <Typography align="center" mt={4}>
                Тариф не найден
            </Typography>
        );

    return (
        <><Head
            title={`Т ${tariff.name} | Лайф Хелп`}
            description={'Помощь квалифицированных психологов от сервиса Лайф Хелп'}
            robots={'noindex, nofollow'}
            canonicalUrl={`${DOMAIN_URL}/tariff/${tariff.id}`}/><FC cls={cls} p={2} g={1} h={'100%'} scroll={'y-auto'}>
            <TariffDetail tariff={tariff}/>
        </FC></>
    );
};

export default TariffPage;
